module.exports = __webpack_public_path__ + "static/media/techlead2.89de80aa.jpg";